// removed by extract-text-webpack-plugin
module.exports = {"root":"Dialog__root___xpV_U","dialog":"Dialog__dialog___3V3we","content":"Dialog__content___34ibk","root--basic":"Dialog__root--basic___3QnLe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Dialog/Dialog.scss
// module id = 1017
// module chunks = 0